import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import emailjs from '@emailjs/browser'; // 🚨 EKLE
import { requestPasswordReset } from '../services/apiService'; // 🚨 YORUM SATIRINDAN ÇIKARILDI

const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
// 🚨 YENİ OLUŞTURDUĞUNUZ ŞABLONUN ID'sini buraya girin.
const EMAILJS_TEMPLATE_ID_RESET = process.env.REACT_APP_EMAILJS_TEMPLATE_ID_RESET;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const logoSrc = (process.env.PUBLIC_URL || "") + "/logo.png"; // public/logo.png


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    try {
      // 1. ADIM: BACKEND'E İSTEK GÖNDER VE LİNKİ AL
      // apiService'de (ve backend'de) kullanıcı yoksa hata fırlatılır.
      const resetLink = await requestPasswordReset(email);

      // 2. ADIM: EMAILJS İLE MAİL GÖNDERME
      if (!EMAILJS_PUBLIC_KEY || !EMAILJS_SERVICE_ID || !EMAILJS_TEMPLATE_ID_RESET) {
        throw new Error("EmailJS anahtarları eksik. E-posta gönderilemedi.");
      }

      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID_RESET,
        {
          user_email: email,   
          reset_link: resetLink   
        },
        EMAILJS_PUBLIC_KEY
      );

      // Başarılı olduğunda kullanıcıya gösterilecek güvenlik mesajı
      setMessage('Eğer e-posta adresiniz sistemimizde kayıtlıysa, şifre sıfırlama bağlantısı gönderilmiştir.');
    } catch (error) {
      console.error('Şifre sıfırlama hatası:', error.message);
      // Hata olsa bile (apiService'in fırlattığı hata dahil), güvenlik için aynı genel mesajı gösterin
      setMessage('Eğer e-posta adresiniz sistemimizde kayıtlıysa, şifre sıfırlama bağlantısı gönderilmiştir.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-rose-50 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex items-center gap-3 group">
            <span className="size-12 md:size-16 rounded-2xl bg-rose-500/10 ring-1 ring-rose-200/50 relative overflow-hidden grid place-items-center">
              <img
                src={logoSrc}
                alt="Anora"
                className="w-[44px] h-[44px] md:w-[60px] md:h-[60px] object-contain"
                aria-hidden
              />
            </span>
            <span className="font-semibold tracking-tight text-3xl text-gray-800">
              <span className="text-[#e45078] font-cormorant font-bold text-3xl">Anora</span>
            </span>
          </Link>
          <h1 className="mt-4 text-2xl font-bold text-gray-700">Şifre Sıfırlama</h1>
          <p className="mt-2 text-sm text-gray-600">Lütfen hesabınıza kayıtlı e-posta adresinizi girin.</p>
        </div>

        <div className="bg-white p-8 rounded-2xl shadow-lg border border-rose-100">
          {message ? (
            <div className="text-center">
              <p className="text-green-700 bg-green-100 p-4 rounded-md">{message}</p>
              <Link to="/owner/login" className="inline-block mt-4 text-sm font-medium text-rose-600 hover:underline">
                Giriş sayfasına dön
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700">E-posta Adresi</label>
                <input
                  id="email"
                  type="email"
                  className="mt-1 w-full p-3 border border-gray-300 rounded-md focus:ring-rose-500 focus:border-rose-500"
                  placeholder="ornek@mail.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-[#e45078] text-white font-bold py-3 px-4 rounded-md hover:bg-rose-600 disabled:bg-rose-300 transition-colors"
              >
                {loading ? 'Gönderiliyor…' : 'Sıfırlama Bağlantısı Gönder'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
